import ApiService from './api.service'

const ContractService = {

	/**
	 * Save or update
	 * New contract
	 * @param data
	 * @returns {*}
	 */
	createOrUpdate: function(data) {
		return ApiService.post(`/contract/add-or-update`, data)
	},


	/**
	 * Get all or
	 * Search contracts
	 * @returns {*}
	 */
	search: function(data) {
		return ApiService.post(`/contract/search`,data)
	},

	deleteContract: function (id) {
		return ApiService.delete(`/contract/delete/${id}`)
	},

	getContract: function(id){
		return ApiService.get(`/contract/get/${id}`)
	}

};

export default ContractService;
